import React, { useState, PropsWithChildren, useMemo } from 'react'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './styles/emptyLink.module.scss'

interface Point {
  x: number
  y: number
}

type EmptyLinkProps = PropsWithChildren<{
  color?: string
}>

const EmptyLink = ({ children, color = '#c7511f' }: EmptyLinkProps) => {
  const [shown, setShown] = useState<Point>(null)
  const viewport = useViewport()
  const { t } = useSurveyLocale()

  const currentViewport = useMemo(() => viewport.width || window.innerWidth, [viewport.width])

  return (
    <>
      {shown && (
        <span
          style={{ left: ` ${shown.x - 6 <= 0 ? 6 : shown.x - 6}px`, top: ` ${shown.y - 20}px`, background: color }}
          className={style.popupLabel}
        >
          {t('questions', 'ec', 'amazon', 'tooltip')}
        </span>
      )}
      <span
        className={style.popupParent}
        onClick={event => {
          setShown({ x: Math.min(event.clientX, currentViewport - 100), y: event.clientY })
          if (!shown) {
            setTimeout(() => setShown(null), 500)
          }
        }}
      >
        {children}
      </span>
    </>
  )
}

export default EmptyLink
